export function CompetitorPlaceholderIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100"
            height="100"
            fill="none"
            viewBox="0 0 100 100"
        >
            <rect
                width="99"
                height="99"
                x="0.5"
                y="0.5"
                fill="#C3C7D3"
                rx="30.5"
            ></rect>
            <rect
                width="99"
                height="99"
                x="0.5"
                y="0.5"
                stroke="#C3C7D3"
                rx="30.5"
            ></rect>
            <path
                fill="#7F8597"
                d="M44.543 43.44l7.853 21.76-22.77-4.079 14.917-17.68z"
            ></path>
            <path
                fill="#7F8597"
                d="M46.572 33.061H60.286V46.775H46.572z"
                transform="rotate(-12.406 46.572 33.06)"
            ></path>
            <circle cx="60.285" cy="55.486" r="6.857" fill="#7F8597"></circle>
        </svg>
    );
}
